export const MIXPANEL_PROJECT_TOKEN = "ca0b6e5e3c5be82d7133a9145c2d1b73";
